module.exports = __webpack_public_path__ + "static/media/about-photo.e5b759aa.jpg";